import * as Yup from "yup";

const itemCatSchema = {};

itemCatSchema.validateItemCatAdd = () => {
  return Yup.object({
    item_cat_name: Yup.string()
      .trim()
      .required("Item Category is required.")
      .min(3, "Item Category name minimum length is 3")
      .max(50, "Item Category name should be at most 50 characters.")
      // .matches(/^[aA-zZ-\s]+$/, "Item Category name should be alphabetic only")
      // .matches(/^[aA-z0-9Z-\s]+$/, `Item Category name should be alphabetic only`),
      .matches(
        /^[a-zA-Z0-9\s!@#$%^&*()_\-+=,.?/\\|[\]{}:;'"`~]+$/,
        "Invalid characters in Item Category name",
      ),
  });
};

itemCatSchema.validateItemCatEdit = () => {
  return Yup.object({
    item_cat_name: Yup.string()
      .trim()
      .required("Item Category name is required.")
      .min(3, "Item Category name minimum length is 3")
      .max(50, "Item Category name should be at most 50 characters.")
      // .matches(/^[aA-zZ-\s]+$/, "Item Category name should be alphabetic only")
      // .matches(/^[aA-z0-9Z-\s]+$/, `Item Category name should be alphabetic only`),
      .matches(
        /^[a-zA-Z0-9\s!@#$%^&*()_\-+=,.?/\\|[\]{}:;'"`~]+$/,
        "Invalid characters in Item Category name",
      ),
  });
};

export default itemCatSchema;
